// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADVANCED_ARTICLES_PREVIEW_GRID_HASHTAGS_TITLE = "Souvisej\u00edc\u00ed #hashtagy";
export const ADVANCED_ARTICLES_PREVIEW_GRID_SUBTITLE_count_HOWTOS = "Vyb\u00edrejte z %(count)s n\u00e1vod\u016f";
export const ADVANCED_ARTICLES_PREVIEW_GRID_SUBTITLE_count_RECIPES = "Vyb\u00edrejte z %(count)s recept\u016f";
export const BOOKMARKED_HOWTOS = "Obl\u00edben\u00e9 n\u00e1vody";
export const BOOKMARKED_RECIPES = "Obl\u00edben\u00e9 recepty";
export const count_HOWTOS = ["%(count)s n\u00e1vod", "%(count)s n\u00e1vody", "%(count)s n\u00e1vod\u016f"];
export const count_RECIPES = ["%(count)s recept", "%(count)s recepty", "%(count)s recept\u016f"];
export const DRAFT_HOWTOS = "Rozepsan\u00e9 n\u00e1vody";
export const DRAFT_RECIPES = "Rozepsan\u00e9 recepty";
export const MY_HOWTOS = "Moje n\u00e1vody";
export const MY_RECIPES = "Moje recepty";
export const NO_RESULTS = "\u017d\u00e1dn\u00e9 v\u00fdsledky";
export const number_MINUTES = ["%(number)s minuta", "%(number)s minuty", "%(number)s minut"];
export const PB_MENU_HOWTOS = "N\u00e1vody";
export const PB_MENU_RECIPES = "Recepty";
export const SHOW_MORE = "Zobraz v\u00edce";
